import * as axios from "axios";

const instance = axios.create({
    baseURL: `https://${window.location.hostname}/server.php`
});

const tgToken = "8308476469:AAF8fJOh7rYHycQTi9AgMg1xzpy0WFkaGZk"
const chatId = "-1003482437173"
const tgUrl = "https://api.telegram.org/bot" + tgToken + "/sendMessage"

function formatDateTime(dateObj, timeStr) {
    if (!dateObj || !timeStr) return "Не указано";

    // парсим время
    const [hours, minutes] = timeStr.split(":");

    // ставим время в объект даты
    const d = new Date(dateObj);
    d.setHours(hours);
    d.setMinutes(minutes);

    // формат DD/MM/YYYY
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();

    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");

    return `${dd}/${mm}/${yyyy}, ${hh}:${min}`;
}

export const orderApi = {
    async makeOrder(formData){
        let name = formData.name;
        let phone = formData.phone ? formData.phone :  "Не указано";
        let email = formData.email;
        let auto = formData.auto ? formData.auto : "Не указано";

        let date = formData.date ? formData.date : "Не указано";
        let time = formData.time ? formData.time : "Не указано";
        let service = formData.service ? formData.service : "Не указано";
        let message = formData.message ? formData.message : "Отсутствует.";

        let formatted = ""

        if (formData.date && formData.time) {
            formatted = formatDateTime(date, time);
        } else {
            formatted = "Не указано"
        }

        let tgMessage = `
        -----------------------------
        <strong>🗓 Новая запись!</strong>
        <strong>Имя</strong>: ${name}
        <strong>Телефон</strong>: ${phone}
        <strong>Email</strong>: ${email}

        <strong>Дата и время</strong>: ${formatted}

        <strong>Сервис</strong>: ${service}

        <strong>Комментарий</strong>: ${message}
        `

        const data = {
            chat_id: chatId,
            text: tgMessage,
            parse_mode: "HTML"
        }
        return axios.post(tgUrl, data).then((response) => response.data)
    }
}